import types from './types';
export default (function (config) {
    var formName = config.name;
    return {
        updateForm: function (value) { return ({
            type: types.FORM_UPDATE,
            formName: formName,
            value: value,
        }); },
        clearForm: function () { return ({
            type: types.FORM_CLEAR,
            formName: formName,
        }); },
        resetForm: function () { return ({
            type: types.FORM_RESET,
            formName: formName,
        }); },
        validateForm: function (validator) { return ({
            type: types.FORM_VALIDATE,
            formName: formName,
            validator: validator,
            key: undefined,
        }); },
        showFormErrors: function (showErrors) { return ({
            type: types.FORM_SHOW_ERRORS,
            formName: formName,
            showErrors: showErrors,
            key: undefined,
        }); },
        updateNode: function (key, value) { return ({
            type: types.NODE_UPDATE,
            formName: formName,
            key: key,
            value: value,
        }); },
        clearNode: function (key) { return ({
            type: types.NODE_CLEAR,
            formName: formName,
            key: key,
        }); },
        resetNode: function (key) { return ({
            type: types.NODE_RESET,
            formName: formName,
            key: key,
        }); },
        validateNode: function (key, validator) { return ({
            type: types.NODE_VALIDATE,
            formName: formName,
            key: key,
            validator: validator,
        }); },
        showNodeErrors: function (key, showErrors) { return ({
            type: types.NODE_SHOW_ERRORS,
            formName: formName,
            key: key,
            showErrors: showErrors,
        }); },
        updateField: function (key, value) { return ({
            type: types.FIELD_UPDATE,
            formName: formName,
            key: key,
            value: value,
        }); },
        focusField: function (key) { return ({
            type: types.FIELD_FOCUSED,
            formName: formName,
            key: key,
        }); },
        blurField: function (key) { return ({
            type: types.FIELD_BLURRED,
            formName: formName,
            key: key,
        }); },
        clearField: function (key) { return ({
            type: types.FIELD_CLEAR,
            formName: formName,
            key: key,
        }); },
        resetField: function (key) { return ({
            type: types.FIELD_RESET,
            formName: formName,
            key: key,
        }); },
        validateField: function (key, validator) { return ({
            type: types.FIELD_VALIDATE,
            formName: formName,
            key: key,
            validator: validator,
        }); },
        showFieldErrors: function (key, showErrors) { return ({
            type: types.FIELD_SHOW_ERRORS,
            formName: formName,
            key: key,
            showErrors: showErrors,
        }); },
        addArrayField: function (key) { return ({
            type: types.ARRAY_FIELD_ADD,
            formName: formName,
            key: key,
        }); },
        deleteArrayField: function (key, index) { return ({
            type: types.ARRAY_FIELD_DELETE,
            formName: formName,
            key: key,
            index: index,
        }); },
    };
});
//# sourceMappingURL=creatorFactory.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/yarfl/es/actions/creatorFactory.js
// module id = 76
// module chunks = 0